<template>
  <div class="tip-pop">
    <i v-if="type" :class="`icon-pop-${type}`"></i>
    <h3>{{ title }}</h3>
    <a v-if="showClose" href="javascript:;" class="close" @click="close"></a>
    <div class="tip-pop__content">
      <slot>
        <p v-html="message"></p>
      </slot>
    </div>
    <div class="tip-pop__footer">
      <button class="confirm" @click="confirm">{{ btnTxt }}</button>
      <button v-if="onCancel" class="cancel" @click="cancel">
        {{ cancelBtnTxt }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '提示'
    },
    type: {
      type: String,
      default: 'tip'
    },
    btnTxt: {
      type: String,
      default: '知道了'
    },
    cancelBtnTxt: {
      type: String,
      default: '取消'
    },
    message: {
      type: String,
      default: ''
    },
    showClose: {
      type: Boolean,
      default: true
    },
    onClose: {
      type: Function,
      default: () => {}
    },
    onConfirm: {
      type: Function,
      default: () => {}
    },
    onCancel: {
      type: Function
    },
    duration: {
      type: Number,
      default: 3000
    },
    isInComp: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      timer: null
    }
  },
  mounted() {
    if (this.duration > 0 && !this.isInComp) {
      this.timer = setTimeout(() => {
        this.close()
      }, this.duration)
    }
  },
  methods: {
    destroyElement() {
      this.$el.parentNode && this.$el.parentNode.removeChild(this.$el)
      this.timer && clearTimeout(this.timer)
      this.$destroy(true)
    },
    close() {
      if (this.isInComp) {
        return this.$emit('close')
      }
      typeof this.onClose === 'function' && this.onClose()
      this.destroyElement()
    },
    confirm() {
      if (this.isInComp) {
        return this.$emit('confirm')
      }
      typeof this.onConfirm === 'function' && this.onConfirm()
      this.destroyElement()
    },
    cancel() {
      if (this.isInComp) {
        return this.$emit('cancel')
      }
      typeof this.onCancel === 'function' && this.onCancel()
      this.destroyElement()
    }
  }
}
</script>
